import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import {
  FaHospital,
  FaUserNurse,
  FaClipboardCheck,
  FaStar,
} from "react-icons/fa";

const statistics = [
  {
    icon: <FaHospital />,
    number: 25,
    suffix: "+",
    label: "Partner Facilities",
  },
  {
    icon: <FaUserNurse />,
    number: 400,
    suffix: "+",
    label: "Healthcare Professionals",
  },
  {
    icon: <FaClipboardCheck />,
    number: 1500,
    suffix: "+",
    label: "Assignments Completed",
  },
  {
    icon: <FaStar />,
    number: 98,
    suffix: "%",
    label: "Client Satisfaction",
  },
];

function Statistics() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.25,
  });

  return (
    <section className="statistics-section" ref={ref}>
      <div className="statistics-container">
        <div className="statistics-heading">
          <p className="section-label">Trusted healthcare staffing</p>
          <h2>Supporting stronger healthcare teams</h2>
        </div>

        <div className="statistics-grid">
          {statistics.map((item) => (
            <article className="statistic-card" key={item.label}>
              <div className="statistic-icon">{item.icon}</div>

              <strong>
                {inView ? (
                  <CountUp
                    start={0}
                    end={item.number}
                    duration={2.5}
                    separator=","
                    suffix={item.suffix}
                  />
                ) : (
                  `0${item.suffix}`
                )}
              </strong>

              <span>{item.label}</span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Statistics;